export const SET_VERSION = "SET_VERSION";

export function setVersion(newVersionModel) {
    return { type: SET_VERSION, versionModel: newVersionModel };
}



// WEBPACK FOOTER //
// ./src/services/store/reducers/version/action.js